import {
  restructureDefaultPropsOfVueCtorFromOptions
} from '@packages/utils'
import AtUploadCtor from './components/main'
import AtImageUploadCtor from './components/ImageUpload'

let AtUpload = AtUploadCtor
let AtImageUpload = AtImageUploadCtor

export {
  AtUpload,
  AtImageUpload
}

export default {
  options: {

    // 文件上传组件，false则不安装
    upload: {},

    // 图片上传组件，false则不安装
    // 只有安装了upload，才能安装imageUpload
    imageUpload: {}
  },
  install(Vue, opts = {}) {
    let {
      upload,
      imageUpload
    } = Object.assign({}, this.options, opts)

    if (upload !== false) {
      Vue.component('at-upload', restructureDefaultPropsOfVueCtorFromOptions(AtUploadCtor, upload))

      if (imageUpload !== false) {
        Vue.component('at-image-upload', restructureDefaultPropsOfVueCtorFromOptions(AtImageUploadCtor, imageUpload))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/upload/index.js